import React, { useState, useEffect } from "react";

// Components
import { Button, Columns, Form, Tabs } from 'react-bulma-components';
import { CompanyDetail, UserAddress } from "shared/components/user";
import Notes from "./Notes";
import Overlay from "shared/components/overlay/Overlay";
import { Phone, Send  } from 'react-feather';

// Constants & utils
import { getUserInitials } from "shared/utils";
import { CONTACT_METHOD, DEFERRED, LEAD_STATUS, STAGES } from "shared/enums";

// Styles
import styles from './AddLead.module.scss';

/* TODO: Add predefined stage when user adds directly in column */
const AddLead = ({ onAddNewLead, onClose, withStage = false }) => {
    const { Input, Field, Control, Label, Select, Textarea } = Form;
    const [newLead, setNewLead] = useState({});
    const [activeTab, setActiveTab] = useState('details');

    const replaceNullUndefined = (obj) => {
        return obj === null || obj === undefined ? '' : obj;
    }

    useEffect(() => {
        if(withStage){
            setNewLead({ stages: withStage });
        }
    }, [withStage]); // empty dependency array means this effect will only run once

    const handleInputChange = (e) => {
        setNewLead(prevState => ({
           ...prevState,
           [e.target.name]: e.target.value
        }));
    }

    const handleNewLead = (e) => {
        e.preventDefault();
        const other = {
            notes: '',
            owner_id: 1,
            user_id: 1
        }
        const newLeadObj = { ...newLead, ...other };

        // parent component handles api request
        onAddNewLead(newLeadObj);
    }

    const handleTabClick = (e) => {
        e.preventDefault();
        setActiveTab(e.target.name);
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setNewLead({});
        onClose();
    }

    const handleOverlayClick = (e) => {
        e.preventDefault();
        onClose();
    }

    return (
        <div className={ styles.wrapper }>
            <div className={ styles.detail }>
                <article className={ styles.inner }>
                    <header className={ styles.header }>
                        <h2>Add New Lead</h2>
                    </header>
                    <Tabs>
                      <Tabs.Tab
                        active={ activeTab === 'details' ? true : false }
                        name="details"
                        onClick={ handleTabClick }>
                        Details
                      </Tabs.Tab>
                      <Tabs.Tab
                        active={ activeTab === 'notes' ? true : false }
                        name="notes"
                        onClick={ handleTabClick }>
                        Notes
                      </Tabs.Tab>
                    </Tabs>
                    <form onSubmit={ handleNewLead }>
                        <div className={ styles.tabContent } style={{ opacity: activeTab === 'details' ? 1 : 0 }}>
                            <div className={ styles.content }>
                                <Field>
                                    <Label>Title</Label>
                                    <Control>
                                        <Input
                                            name="title"
                                            onChange={ handleInputChange }
                                            required
                                            value={ replaceNullUndefined(newLead.title) }
                                        />
                                    </Control>
                                </Field>
                                <Field>
                                    <Label>Contact Method</Label>
                                    <Control>
                                        <Select
                                            name="contact_method"
                                            onChange={ handleInputChange }
                                            value={ replaceNullUndefined(newLead.contact_method) }>
                                            <option value="">
                                                - Choose an option -
                                            </option>
                                            { Object.entries(CONTACT_METHOD).map(([status, label], i) => {
                                                return (
                                                    <option key={i} value={ status}>
                                                        {label}
                                                    </option> )
                                                })
                                            }
                                        </Select>
                                    </Control>
                                </Field>
                                <Field style={{ flexBasis: '95%'}}>
                                    <Label>Description</Label>
                                    <Control>
                                        <Textarea
                                            onChange={ handleInputChange }
                                            name="description"
                                            value={ newLead.description }
                                        />
                                    </Control>
                                </Field>
                            </div>
                            <div className={ styles.lead }>
                                <Field>
                                    <Label>Lead Status</Label>
                                    <Control>
                                        <Select
                                            name="status"
                                            required
                                            onChange={ handleInputChange }
                                            value={ replaceNullUndefined(newLead.status) }>
                                            <option value="">
                                                - Choose an option -
                                            </option>
                                            { Object.entries(LEAD_STATUS).map(([status, label], i) => {
                                                return (
                                                    <option key={i} value={ status}>
                                                        {label}
                                                    </option> )
                                                })
                                            }
                                        </Select>
                                        {
                                            newLead.status === 'deferred' &&
                                            <Select
                                                name="deferred"
                                                required
                                                onChange={ handleInputChange }
                                                style={{ marginTop: '1.5rem'}}
                                                value={ replaceNullUndefined(newLead.deferred) }>
                                                <option value="">
                                                    - Choose a Deferred state -
                                                </option>
                                                { Object.entries(DEFERRED).map(([def, label], i) => {
                                                    return (
                                                        <option key={i} value={ def }>
                                                            { label }
                                                        </option> )
                                                    })
                                                }
                                            </Select>
                                        }
                                    </Control>
                                </Field>
                                <Field>
                                    <Label>Lead Stages</Label>
                                    <Control>
                                        <Select
                                            className={ styles[newLead.stages] }
                                            onChange={ handleInputChange }
                                            name="stages"
                                            required
                                            value={ newLead.stages }>
                                            <option value="">
                                                - Choose an option -
                                            </option>
                                            { Object.entries(STAGES).map(([status, label], i) => {
                                                return (
                                                    <option key={i} value={ status}>
                                                        {label}
                                                    </option> )
                                                })
                                            }
                                        </Select>
                                    </Control>
                                </Field>
                            </div>
                        </div>

                        <div className={ styles.tabContent } style={{ opacity: activeTab === 'notes' ? 1 : 0 }}>
                            <Notes data={ replaceNullUndefined(newLead.notes) }/>
                        </div>

                        <footer className={ styles.actions }>
                            <Button onClick={ handleCancel }>
                                Cancel
                            </Button>
                            <Button
                                className={ styles.secondary }
                                type="submit">
                                Add New Lead
                            </Button>
                        </footer>
                    </form>
                </article>
            </div>
            <Overlay isContained onClick={ handleOverlayClick }/>
        </div>
    )
}

export default AddLead;
